import PaymentSuccessfulPage from "./PaymentSuccessfulPage";

export default PaymentSuccessfulPage;
